module.exports = ".font-white {\n  color: white !important; }\n"